import { formatTimeString } from '../../utils/formatters'
import BaseExporter from './base_exporter'

export default class InsightsExporter extends BaseExporter {
  export() {
    const txIdentityFields = ['client_guid', 'first_name', 'last_name', 'country_code']
    const txFields = ['created', 'updated', 'state']
    const metadataFields = ['face_match_score']

    const data = this.data.map((entry) => {
      let dataRow = []
      if (!entry) {
        return new Array(this.header.length)
      }
      if (entry.hasOwnProperty('transaction_identity') && entry.transaction_identity) {
        for (let i = 0; i < txIdentityFields.length; i++) {
          if (entry.transaction_identity.hasOwnProperty(txIdentityFields[i])) {
            dataRow.push(entry.transaction_identity[txIdentityFields[i]])
          } else {
            dataRow.push(null)
          }
        }
      } else {
        txIdentityFields.map(() => dataRow.push(null))
      }
      for (let i = 0; i < txFields.length; i++) {
        if (entry.hasOwnProperty(txFields[i]) && entry[txFields[i]]) {
          if (txFields[i] === 'state') {
            dataRow.push(entry[txFields[i]])
          } else {
            dataRow.push(formatTimeString(entry[txFields[i]]))
          }
        } else {
          dataRow.push(null)
        }
      }
      if (entry.hasOwnProperty('transaction_identity') && entry.transaction_identity) {
        if (entry.transaction_identity.hasOwnProperty('is_accredited_investor')) {
          dataRow.push(entry.transaction_identity.is_accredited_investor.toString())
        } else {
          dataRow.push(null)
        }

        if (
          entry.transaction_identity.hasOwnProperty('identity_accredited_investor_status') &&
          entry.transaction_identity.identity_accredited_investor_status &&
          entry.transaction_identity.identity_accredited_investor_status.hasOwnProperty('status') &&
          entry.transaction_identity.identity_accredited_investor_status.status
        ) {
          dataRow.push(entry.transaction_identity.identity_accredited_investor_status.status)
        } else {
          dataRow.push(null)
        }
      } else {
        let i = 0
        while (i < 2) {
          dataRow.push(null)
          i++
        }
      }
      if (entry.transaction_metadata) {
        metadataFields.forEach((t) =>
          dataRow.push(entry.transaction_metadata.hasOwnProperty(t) ? entry.transaction_metadata[t] : null)
        )
      } else {
        metadataFields.map(() => dataRow.push(null))
      }

      if (entry.transaction_identity && entry.transaction_identity.errors && entry.transaction_identity.errors.length) {
        dataRow.push(entry.transaction_identity.errors.map((e) => e.error_code.error_code_name))
      } else {
        dataRow.push(null)
      }
      return dataRow
    })
    data.unshift(this.header)
    return data
  }
}
